module.exports = __webpack_public_path__ + "img/门禁报警系统V1.0.396b663c.jpg";